import * as React from 'react';
import { app, dialog, UrlDialogInfo } from "@microsoft/teams-js";
import { getUserSettings, updateUserSettings, updateLastSelectedView, updateSelectedLanguage } from '../../api/user-api';
import { getLanguage, getAppSettings } from '../../api/settings-api';
import {
    getMeetingsData,
    getMeetingsDataPaged,
    getGeneralViewData,
    getMetricsData,
    getActiveUnidadesData,
    getAttendancesReportData,
    deleteServentia,
    isAdmin,
    getUserPermissions,
    getAppSetup,
    getReportUrl
} from '../../api/teamsapp-api';
import { Button, Checkbox, Flex, FlexItem, Segment, Dropdown, MenuButton, Text, Grid, Tooltip, CheckboxProps } from '@fluentui/react-northstar';
import { CalendarIcon, MoreIcon, EditIcon, ShareGenericIcon, ThumbtackIcon, WindowRestoreIcon, ExclamationTriangleIcon } from '@fluentui/react-icons-northstar';
import { initializeIcons, Icon } from '@fluentui/react';
import { Chart } from "../chart/chart";
import { debounce } from 'lodash';
import { withTranslation } from "react-i18next";
import { updateLocale } from '../../i18n';
import { EChartTypes } from "../chart/chart-types";
import { TFunction } from "i18next";
import { IDetailsListServentiasState, IDetailsListServentiasProps, ISecaoJudiciaria } from "./interfaces/interfaces";
import { Loader, LoaderList } from "../loaders/loaders";
import Pagination from '../pagination/pagination';
import ServentiaFilters from '../../constants/serventias-filters';
import Errors from "../../constants/errors";
import Roles from "../../constants/roles";
import Flags from '../../constants/flags';
import Features from '../../constants/features';
import VisaoGeralAtendimentos from '../shared/visao-geral-atendimentos/visao-geral-atendimentos';
import VisaoGeralUnidades from './visao-geral-unidades/visao-geral-unidades';
import RelatorioAtendimentos from '../shared/relatorio-atendimentos/relatorio-atendimentos';
import ToolbarHome from "./toolbar/toolbar";

import "./home.scss";

class Serventias extends React.Component<IDetailsListServentiasProps, IDetailsListServentiasState> {
    private defaultPageSize: number = 10;
    private localize: TFunction;
    private searchParam?: any = null;
    private upn?: any = null;
    private aadId?: any = null;
    private user?: any = null;
    private tid?: any = null;
    private loginHint?: any = null;
    private locale?: any = null;
    private theme?: any = null;
    private flagPT: string;
    private flagEN: string;
    private flagES: string;
    private appId: string;
    private preSelectedCategory: string;

    constructor(props: IDetailsListServentiasProps) {
        super(props);
        this.localize = this.props.t;

        initializeIcons();
        this.onChangeDebounced = debounce(this.onChangeDebounced, 500);
        this.searchParam = new URLSearchParams(window.location.search);

        if (this.searchParam.get("cat")) {
            this.preSelectedCategory = decodeURIComponent(this.searchParam.get("cat"));
        }

        this.flagPT = Flags.flagPT;
        this.flagEN = Flags.flagEN;
        this.flagES = Flags.flagES;

        this.state = {
            totalItemsCount: [],
            items: [],
            selectedItem: [],
            itemsClone: [],
            loading: true,
            pageSize: this.defaultPageSize,
            activePage: 0,
            sortedColumn: "",
            sortDirection: "Down",
            sortDirectionSecao: "Down",
            sortDirectionFluxo: "Down",
            sortDirectionHoje: "Down",
            totalFilterChecked: 0,
            itemsSecaoFilter: [],
            relatorioAtendimentosFilteredMetrics: [],
            loadingMetricsFiltered: false,
            relatorioAtendimentosIndex: 0,
            atendimentosMetricsFiltered: [],
            atendimentosIndex: 0,
            loadingAtendimentosMetricsFiltered: false,
            atendimentosTotalMetrics: [],
            loadingAtendimentosTotalMetrics: false,
            unidadesMetricsFiltered: [],
            loadingUnidadesMetricsFiltered: false,
            unidadesIndex: 0,
            loadingRows: false,
            segmentRows: [],
            isAdmin: false,
            searchFilter: "",
            userSettings: [],
            pinnedAncoras: [],
            role: Roles.leitor,
            secaoJudiciariaChecked: "",
            viewFilters: [],
            selectedViewFilter: null,
            selectedViewFilterLocale: null,
            setup: null,
            reportUrl: undefined,
            language: "",
            flagImage: "",
            collapsed: true,
            features: [],
        };
    }

    public componentDidMount = async () => {
        app.initialize();
        app.getContext().then((context: app.Context) => {
            this.upn = context.user.userPrincipalName;
            this.aadId = context.user.id;
            this.user = context.user.loginHint;
            this.tid = context.user.tenant;
            this.loginHint = context.user.loginHint;
            this.locale = context.app.locale;
            this.theme = context.app.theme;
            this.appId = this.searchParam.get("appId");

            this.setupApp();
            this.isAdmin();
            this.userPermissions();
            this.setupUser();
        });
    }

    //Init app methods.
    private init = async () => {
        this.getAppSettings();
        this.getPageSize();
        this.getMeetingsData(true);
        this.getMeetingsPagedData(0, this.defaultPageSize);
        this.getAtendimentosFilteredMetrics(0);
        this.getAtendimentosTotalMetrics();
        this.getUnidadesFilteredMetrics(7);
        this.getRelatorioAtendimentosFilteredMetrics(7);
    }

    //Get user permissions.
    private userPermissions = async () => {
        let response = await getUserPermissions();

        if (response) {
            this.setState({
                role: response.data
            })
        }
    }

    //Get app settings.
    public getAppSettings = async () => {
        let response = await getAppSettings();

        if (response.status === 200 && response.data) {
            this.setState({
                features: response.data.featuresList,
            })
        }
    }

    //Setup app & Report.
    private setupApp = async () => {
        let responseSetup = await getAppSetup();
        let responseReport = await getReportUrl();

        if (responseSetup && responseReport) {
            this.setState({
                setup: responseSetup.data,
                reportUrl: responseReport.data,
            })
        }
    }

    //Setup user settings
    private setupUser = async () => {
        let responseUser = await getUserSettings(this.loginHint);
        let responseConfig = await getLanguage();

        if (responseUser.data.language) {
            this.setState({
                language: responseUser.data.language,
            });
        } else {
            if (responseConfig.data.language) {
                this.setState({
                    language: responseConfig.data.language,
                })

            } else {
                this.setState({
                    language: this.locale
                });
            }
        }

        if (responseUser.data) {
            this.setState({
                userSettings: responseUser.data,
                pinnedAncoras: responseUser.data.PinnedAncoras || [],
                selectedViewFilter: responseUser.data.LastSelectedView,
                selectedViewFilterLocale: this.localeSelectedView(responseUser.data.LastSelectedView),
            })

            this.init();
        } else {
            window.location.href = `/errorpage/${Errors.invalidUserData}`;

            this.init()
        }
    }

    //Update favorites.
    private updateFavorites = async (userSettings: any) => {
        let responseUpdate = await updateUserSettings(userSettings);

        if (responseUpdate.status === 200 && responseUpdate.data) {
            this.setState({
                pinnedAncoras: responseUpdate.data
            })
        }
    }

    //Get Page size initial.
    private getPageSize = async () => {
        this.setState({
            pageSize: 10
        });
    }

    /**
     * Get Meetings Data
     * */
    private async getMeetingsData(render?: boolean, filterView?: any) {
        let filter = this.state.searchFilter != "" ? this.state.searchFilter : undefined;
        let secaoJudiciaria = this.state.secaoJudiciariaChecked != "" ? this.state.secaoJudiciariaChecked : undefined;
        filterView = filterView ? filterView : this.state.selectedViewFilter;

        let pinnedAncoras = null;

        if (this.state.pinnedAncoras) {
            pinnedAncoras = this.state.pinnedAncoras.length ? this.state.pinnedAncoras : null;
        }

        if (this.preSelectedCategory) {
            secaoJudiciaria = this.preSelectedCategory;
        }

        if (!render) {
            this.setState({
                loadingRows: true,
            });
        } else {
            this.setState({
                loading: true,
            });
        }

        let response = await getMeetingsData(filter, secaoJudiciaria, filterView, pinnedAncoras);

        if (response.status === 200 && response.data) {
            const secaoJudiciaria: ISecaoJudiciaria[] = [];

            response.data.secoesJudiciarias.sort().forEach((item: any) => {
                if (item == null || item == "") {
                    return;
                }

                let itemSecaoJudiciaria: ISecaoJudiciaria = { name: item, isSelected: item == this.state.secaoJudiciariaChecked ? true : false };
                secaoJudiciaria.push(itemSecaoJudiciaria);
            })

            this.setState({
                totalItemsCount: response.data.count,
                loading: false,
                selectedViewFilter: this.state.selectedViewFilter ? this.state.selectedViewFilter : response.data.selectedViewFilter,
                itemsSecaoFilter: secaoJudiciaria,
            })
        }
        else {
            this.setState({
                loadingRows: false,
                loading: false,
                totalItemsCount: 0,
            })
        }
    }

    /**
     * Get Filtered Meetings Data
     * */
    private async getMeetingsPagedData(
        offset: number,
        limit: number,
        filter?: string,
        sortProperty?: string,
        sortType?: string,
        secaoJudiciaria?: string,
        filterView?: any,
    ) {
        filter = filter ? filter : undefined;
        secaoJudiciaria = secaoJudiciaria ? secaoJudiciaria : undefined;
        filterView = filterView ? filterView : this.state.selectedViewFilter;

        let pinnedAncoras = null;

        if (this.state.pinnedAncoras) {
            pinnedAncoras = this.state.pinnedAncoras.length ? this.state.pinnedAncoras : null;
        }

        if (this.preSelectedCategory) {
            secaoJudiciaria = this.preSelectedCategory;
        }

        this.setState({
            segmentRows: [],
            loadingRows: true,
            activePage: offset
        });

        const response = await getMeetingsDataPaged(offset, limit, filter, sortProperty, sortType, secaoJudiciaria, pinnedAncoras, filterView);

        if (response.status === 200 && response.data) {
            this.setState({
                items: response.data,
                itemsClone: response.data,
            });

            this.populateRows()
        }
    }

    /**
     * Get App Configs
     * */
    private async isAdmin() {
        try {
            let response = await isAdmin();

            if (response.status === 200 && response.data) {
                this.setState({
                    isAdmin: response.data,
                    role: Roles.gestor,
                });
            } else {
                this.setState({
                    isAdmin: false,
                });
            }
        } catch (err) {
            this.setState({
                isAdmin: false,
            });
        }
    };

    /**
     * Set selected view locale.
     * */
    public localeSelectedView = (selectedView: string | null) => {
        if (selectedView) {
            if (selectedView == ServentiaFilters.ativos)
                selectedView = this.localize("FiltroAtivos")
            else if (selectedView == ServentiaFilters.excluidos)
                selectedView = this.localize("FiltroExcluidos")
            else if (selectedView == ServentiaFilters.todos)
                selectedView = this.localize("FiltroTodos")
            else
                selectedView = this.localize("FiltroFavoritos")
        }

        return selectedView;
    }

    /**
     * Get Filtered Metrics Data
     * */
    public getRelatorioAtendimentosFilteredMetrics = async (daysCount: any, index?: number) => {
        if (index == null) {
            this.setState({
                loadingMetricsFiltered: true,
            });
        }

        let response = await getAttendancesReportData(daysCount);
        if (response.status === 200 && response.data) {
            this.setState({
                relatorioAtendimentosFilteredMetrics: response.data,
                loadingMetricsFiltered: false,
                relatorioAtendimentosIndex: index == null ? 0 : index,
            });
        } else {
            this.setState({
                relatorioAtendimentosFilteredMetrics: null,
                loadingMetricsFiltered: false,
            });
        }
    }

    /**
     * Get visão geral filter metrics
     * */
    public getAtendimentosFilteredMetrics = async (daysCount: any, index?: number) => {
        if (index == null) {
            this.setState({
                loadingAtendimentosMetricsFiltered: true,
            });
        }

        let response = await getGeneralViewData(daysCount);
        if (response.status === 200 && response.data) {
            this.setState({
                atendimentosMetricsFiltered: response.data,
                loadingAtendimentosMetricsFiltered: false,
                atendimentosIndex: index == null ? 0 : index,
            });
        } else {
            this.setState({
                atendimentosMetricsFiltered: null,
                loadingAtendimentosMetricsFiltered: false,
            });
        }
    }

    /**
     * Get visão geral total metrics
     * */
    public getAtendimentosTotalMetrics = async () => {
        this.setState({
            loadingAtendimentosTotalMetrics: true,
        });

        let response = await getMetricsData();
        if (response.status === 200 && response.data) {
            this.setState({
                atendimentosTotalMetrics: response.data,
                loadingAtendimentosTotalMetrics: false,
            });
        } else {
            this.setState({
                atendimentosTotalMetrics: null,
                loadingAtendimentosTotalMetrics: false,
            })
        }
    }

    /**
     * Get visão geral unidades
     * */
    public getUnidadesFilteredMetrics = async (daysCount: any, index?: number) => {
        if (index == null) {
            this.setState({
                loadingUnidadesMetricsFiltered: true,
            });
        }

        let response = await getActiveUnidadesData(daysCount);
        if (response.status === 200 && response.data) {
            this.setState({
                unidadesMetricsFiltered: response.data,
                loadingUnidadesMetricsFiltered: false,
                unidadesIndex: index == null ? 0 : index,
            });
        } else {
            this.setState({
                unidadesMetricsFiltered: null,
                loadingUnidadesMetricsFiltered: false,
            });
        }
    }

    //"Search function"
    private search = (e: React.SyntheticEvent<HTMLElement, Event>) => {
        let searchQuery = (e.target as HTMLInputElement).value;

        this.onChangeDebounced(searchQuery.toLowerCase())
    }

    private onChangeDebounced = (queryText: string) => {
        this.setState({ searchFilter: queryText })
        this.getMeetingsData()
        this.getMeetingsPagedData(0, this.state.pageSize, queryText, undefined, undefined, this.state.secaoJudiciariaChecked, this.state.selectedViewFilter)
    }

    // "Individual record checkbox selected"
    private selectCheckboxChanged = (e: React.SyntheticEvent<HTMLElement, Event>, v?: CheckboxProps) => {
        const selectedChkId = (e.currentTarget as Element).id;

        this.state.items.forEach((currentItem: any) => {
            if (currentItem.ancora === selectedChkId) {
                currentItem.isSelected = v!.checked ? v!.checked : false;
                this.setState({ selectedItem: currentItem })
            }
            else {
                currentItem.isSelected = false;
            }
        });

        this.setState({
            items: this.state.items
        })

        this.populateRows()
    }

    // "Set favorite item"
    private setFavorite = (item: any, ancora: string, index: number) => {
        if (item.favorite) {
            var indexAncora = this.state.pinnedAncoras.indexOf(ancora);

            if (indexAncora > -1) {
                this.state.pinnedAncoras.splice(indexAncora, 1)
            }
        } else {
            this.state.pinnedAncoras.push(ancora);
        }

        this.updateFavorites(this.state.userSettings);

        const favoriteItem = [...this.state.items];
        favoriteItem[index].favorite = item.favorite ? false : true;
        this.setState({ items: favoriteItem });

        this.populateRows();
    }

    //#region "Sorting functions"

    //Calling appropriate function based on column selected for sorting
    private sortDataByColumn = (column: string, sortState: any) => {
        let directionBool = false;

        const direction = this.state[sortState as keyof IDetailsListServentiasState] === "Up" ? "Down" : "Up";
        this.setState({
            sortedColumn: column,
            [sortState]: direction
        } as Pick<IDetailsListServentiasState, keyof IDetailsListServentiasState>);
        directionBool = this.state[sortState as keyof IDetailsListServentiasState] === "Up" ? true : false;

        this.sortColumnItems(column, directionBool)
    }

    //Setting the sort icons and sorting pinned-unpinned records separately
    private sortColumnItems = (sortColumn: string, sortOrder: boolean) => {
        let sorted = sortOrder === true ? "asc" : "desc";

        if (sortColumn == "Favorite") {
            sorted = "asc";
        }

        this.getMeetingsPagedData(0, this.state.pageSize, this.state.searchFilter, sortColumn, sorted, this.state.secaoJudiciariaChecked, this.state.selectedViewFilter);
    }
    //#endregion "Sorting functions"

    private selectFilter = (e: React.SyntheticEvent<HTMLElement, Event>, v?: CheckboxProps) => {
        const selectedChkId = (e.currentTarget as Element).id;

        if (v!.checked) {
            this.setState({
                totalFilterChecked: /*this.state.totalFilterChecked +*/ 1,
                secaoJudiciariaChecked: selectedChkId,
                activePage: 0
            }, () => {
                this.getMeetingsData();
                this.getMeetingsPagedData(0, this.state.pageSize, this.state.searchFilter, this.state.sortedColumn, this.state.sortDirection, selectedChkId, this.state.selectedViewFilter);
            });
        }
        else {
            this.setState({
                totalFilterChecked: this.state.totalFilterChecked - 1,
                secaoJudiciariaChecked: "",
                activePage: 0
            }, () => {
                this.getMeetingsData();
                this.getMeetingsPagedData(0, this.state.pageSize, this.state.searchFilter)
            });
        }

        this.state.itemsSecaoFilter.forEach((currentItem: any) => {
            if (currentItem.name === selectedChkId) {
                currentItem.isSelected = v!.checked ? v!.checked : false;
            }
            else {
                currentItem.isSelected = false;
            }
        });

        this.setState({
            itemsSecaoFilter: this.state.itemsSecaoFilter
        });
    }

    private clearFilter = () => {
        this.state.itemsSecaoFilter.forEach((currentItem: any) => {
            currentItem.isSelected = false;
        });

        this.setState({
            totalFilterChecked: 0,
            itemsSecaoFilter: this.state.itemsSecaoFilter,
            activePage: 0,
            secaoJudiciariaChecked: ""
        }, () => {
            this.getMeetingsData();
            this.getMeetingsPagedData(0, this.state.pageSize, this.state.searchFilter);
        });
    }

    private renderFilters = (item: any, index: number) => {
        return (
            <div key={index}>
                {this.state.itemsSecaoFilter.length > 0 &&
                    <Flex>
                        <FlexItem>
                            <Text content={item.name} />
                        </FlexItem>
                        <FlexItem push>
                            <Checkbox key={item.name} id={item.name} checked={this.preSelectedCategory ? true : item.isSelected} onClick={this.selectFilter.bind(this)} className="group-checkbox dark-theme" />
                        </FlexItem>
                    </Flex>
                }
            </div>
        )
    }

    private setActivePage = (newPageNumber: number) => {
        let sorted = undefined;

        if (this.state.sortedColumn == "Name") {
            sorted = this.state.sortDirection === "Down" ? "asc" : "desc";
        }

        this.getMeetingsPagedData(newPageNumber * this.state.pageSize, this.state.pageSize, this.state.searchFilter, this.state.sortedColumn, sorted, this.state.secaoJudiciariaChecked, this.state.selectedViewFilter)
        this.setState({
            activePage: newPageNumber,
        })
    }

    public onNewBalcaoVirtual = () => {
        let taskInfo: UrlDialogInfo = {
            url: window.location.origin + "/form-balcao-virtual",
            title: this.localize("NovoBalcaoVirtual"),
            size: {
                height: 360,
                width: 600,
            },
            fallbackUrl: window.location.origin + "/form-balcao-virtual",
        }

        let submitHandler = (submitHandler): void => {
            this.getMeetingsPagedData(0, this.state.pageSize, this.state.searchFilter, undefined, undefined, this.state.secaoJudiciariaChecked, this.state.selectedViewFilter);
        };

        dialog.url.open(taskInfo, submitHandler);
    }

    public onEditBalcaoVirtual = (ancora: string) => {
        let taskInfo: UrlDialogInfo = {
            url: window.location.origin + `/form-balcao-virtual/${ancora}`,
            title: this.localize("EditarBalcaoVirtual"),
            size: {
                height: 650,
                width: 750,
            },
            fallbackUrl: window.location.origin + `/form-balcao-virtual/${ancora}`,
        }

        let submitHandler = (submitHandler): void => {
            if (submitHandler.result == "submit")
                this.getMeetingsPagedData(0, this.state.pageSize, this.state.searchFilter, undefined, undefined, this.state.secaoJudiciariaChecked, this.state.selectedViewFilter);
        };

        dialog.url.open(taskInfo, submitHandler);
    }

    public configAppSettings = () => {
        let taskInfo: UrlDialogInfo = {
            url: window.location.origin + `/settings/${this.aadId}/${this.appId}`,
            title: this.localize("Configuracao"),
            size: {
                height: 650,
                width: 750,
            },
            fallbackUrl: window.location.origin + `/settings/${this.aadId}/${this.appId}`,
        }

        let submitHandler = (submitHandler): void => {
            if (submitHandler != null && !submitHandler.err?.includes("User cancelled")) {
                this.setState({
                    loading: true,
                })

                updateLocale(submitHandler.result);
                this.forceUpdate();

                setTimeout(() => this.setupUser(), 1000);
            }
        };

        dialog.url.open(taskInfo, submitHandler);
    }

    public agendar = (ancora: string) => {
        const cat = this.searchParam.get("cat");

        let url = `${window.location.origin}/agendamento?ancora=${ancora}&appId=${this.searchParam.get("appId")}`;

        if (cat) {
            url += `&cat=${cat}`;
        }

        let taskInfo: UrlDialogInfo = {
            url,
            title: this.localize("Agendamento"),
            size: {
                height: 600,
                width: 800,
            },
        }

        let submitHandler = (submitHandler): void => { };

        dialog.url.open(taskInfo, submitHandler);
    }

    public dashboardTask = () => {
        window.open(this.state.reportUrl + `&filterPaneEnabled=false&navContentPaneEnabled=false`, '_blank');
    }

    public homeTask = () => {
        window.open(window.location.origin, '_blank');
    }

    public copyEnderecoPublicoToClipboard = (ancora: string) => {
        const el = document.createElement('input');
        el.style.position = 'fixed';
        el.style.left = '0';
        el.style.top = '0';
        el.style.opacity = '0';
        el.value = window.location.origin + "/meeting/" + ancora;
        document.body.appendChild(el);
        el.focus();
        el.select();

        document.execCommand("copy")
        document.body.removeChild(el);
    }

    public onDeleteBalcaoVirtual = async (ancora: string) => {
        if (this.state.pinnedAncoras) {
            let indexAncora = this.state.pinnedAncoras.indexOf(ancora);

            if (indexAncora > -1) {
                this.state.pinnedAncoras.splice(indexAncora, 1)
            }

            this.updateFavorites(this.state.userSettings)
        }

        let response = await deleteServentia(ancora);

        if (response.status === 200 && response.data) {
            this.getMeetingsPagedData(0, this.state.pageSize)
        }
    }

    public saveSelectedView = async (selectedView: string) => {
        await updateLastSelectedView(selectedView);
    }

    public saveSelectedLanguage = async (language: any) => {
        await updateSelectedLanguage(language);
    }

    public onLanguageChange = (locale: string) => {
        this.setState({
            language: locale,
            loading: true,
        });

        this.saveSelectedLanguage(locale);
        updateLocale(locale);
        this.forceUpdate();

        setTimeout(() => this.setupUser(), 1000);
    }

    public parseLocale = (lang: string) => {
        if (lang == this.localize("Portugues"))
            return "pt-BR";
        else if (lang == this.localize("Ingles"))
            return "en-US";
        else if (lang == this.localize("Espanhol"))
            return "es-ES";
    }

    public parseLang = (locale: string) => {
        if (locale == "pt-BR")
            return this.localize("Portugues")
        else if (locale == "en-US")
            return this.localize("Ingles")
        else if (locale == "es-ES")
            return this.localize("Espanhol")
    }

    public collapseCharts = (collapsed: boolean) => {
        this.setState({
            collapsed: collapsed
        })
    }

    public isLoading = () => {
        return (
            this.state.loading ||
            this.state.loadingAtendimentosMetricsFiltered ||
            this.state.loadingAtendimentosTotalMetrics ||
            this.state.loadingUnidadesMetricsFiltered ||
            this.state.loadingMetricsFiltered
        )
    }

    public filterView = (item: any) => {
        this.setState({ selectedViewFilterLocale: item })

        if (item == this.localize("FiltroAtivos"))
            item = ServentiaFilters.ativos;
        else if (item == this.localize("FiltroExcluidos"))
            item = ServentiaFilters.excluidos;
        else if (item == this.localize("FiltroTodos"))
            item = ServentiaFilters.todos;
        else
            item = ServentiaFilters.favoritos


        this.saveSelectedView(item);
        this.getMeetingsData(undefined, item);
        this.getMeetingsPagedData(0, this.state.pageSize, this.state.searchFilter, undefined, undefined, this.state.secaoJudiciariaChecked, item)

        this.setState({
            activePage: 0,
            pageSize: this.state.pageSize,
            selectedViewFilter: item,
        });

        return item.content;
    }

    public populateRows = () => {
        let itemsArr = [];

        if (this.state.items.length) {
            for (let j: number = 0; j < this.state.items.length; j++) {
                if (j >= this.state.items.length) {
                    break;
                }

                const item = this.state.items[j];

                if (this.state.pinnedAncoras) {
                    if (this.state.pinnedAncoras.some((p: any) => p === item.ancora)) {
                        item.favorite = true
                    } else {
                        item.favorite = false
                    }
                }

                itemsArr.push(
                    <React.Fragment key={j}>
                        <Flex gap="gap.medium" vAlign="center" className={item.isSelected ? "row row-active" : "row"}>
                            <FlexItem>
                                {(!this.state.isAdmin && this.state.role != Roles.gestor && !item.isAuthorized) ?
                                    <Text styles={{ marginLeft: "3.5rem" }} content={item.serventia} />
                                    :
                                    <Flex gap="gap.small" vAlign="center">
                                        <Checkbox
                                            key={item.ancora}
                                            id={item.ancora}
                                            checked={item.isSelected}
                                            onClick={this.selectCheckboxChanged.bind(this)}
                                            className={item.deleted ? "deleted group-checkbox dark-theme" : "group-checkbox dark-theme"}
                                        />
                                        <Text onClick={() => {
                                            console.log(item.ancora, item.serventia);
                                            const url = window.location.ancestorOrigins[0].includes("cloud") ?
                                                `https://teams.cloud.microsoft/l/entity/${this.searchParam.get("appId")}/painel?context=${encodeURI('{"subEntityId": "' + item.ancora + ', ' + encodeURIComponent(item.serventia) + '"}')}` :
                                                `https://teams.microsoft.com/l/entity/${this.searchParam.get("appId")}/painel?context=${encodeURI('{"subEntityId": "' + item.ancora + ', ' + encodeURIComponent(item.serventia) + '"}')}`

                                            app.openLink(url)
                                        }}
                                            styles={{ cursor: "pointer" }}
                                            className="text-ms-color"
                                            content={item.serventia}
                                        />
                                    </Flex>
                                }

                            </FlexItem>
                        </Flex>

                        <Flex gap="gap.medium" vAlign="center" className={item.isSelected ? "row row-active" : "row"}>
                            <div hidden={(!this.state.isAdmin && this.state.role != Roles.gestor && !item.isAuthorized)}>
                                <FlexItem>
                                    <MenuButton
                                        tabIndex={-1}
                                        trigger={<Button icon={<MoreIcon />} iconOnly text />}
                                        on="click"
                                        menu={[
                                            {
                                                key: 'edit',
                                                content: this.localize("Editar"),
                                                icon: <EditIcon outline />,
                                                onClick: () => this.onEditBalcaoVirtual(item.ancora),
                                                hidden: !this.state.isAdmin && (this.state.role == Roles.leitor || this.state.role == Roles.atendente) || !this.state.setup,
                                            },
                                            {
                                                key: 'service',
                                                content: this.localize("MostrarAtendimento"),
                                                icon: <ShareGenericIcon outline />,
                                                onClick: () => {
                                                    const url = window.location.ancestorOrigins[0].includes("cloud") ?
                                                        `https://teams.cloud.microsoft/l/entity/${this.searchParam.get("appId")}/painel?context=${encodeURI('{"subEntityId": "' + item.ancora + ', ' + encodeURIComponent(item.serventia) + '"}')}` :
                                                        `https://teams.microsoft.com/l/entity/${this.searchParam.get("appId")}/painel?context=${encodeURI('{"subEntityId": "' + item.ancora + ', ' + encodeURIComponent(item.serventia) + '"}')}`
                                                    app.openLink(url)
                                                },
                                                hidden: !this.state.isAdmin && (this.state.role == Roles.leitor && !item.isAuthorized),
                                            },
                                            {
                                                ...(this.state.features.includes(Features.ScheduledQueue) ?
                                                    {
                                                        key: 'schedule',
                                                        content: this.localize("NovoAgendamento"),
                                                        icon: <CalendarIcon outline />,
                                                        onClick: () => this.agendar(item.ancora),
                                                        hidden: (!this.state.isAdmin && this.state.role != Roles.gestor && !item.isAuthorized) || !this.state.setup || !item.scheduledQueue,
                                                    }
                                                    :
                                                    {
                                                        key: 'empty',
                                                        className: 'empty',
                                                    }
                                                )
                                            },
                                            {
                                                key: 'copy',
                                                content: this.localize("CopiarURL"),
                                                icon: <WindowRestoreIcon outline />,
                                                onClick: () => this.copyEnderecoPublicoToClipboard(item.ancora),
                                                hidden: (!this.state.isAdmin && this.state.role != Roles.gestor && !item.isAuthorized),
                                            },
                                        ]}
                                    />
                                </FlexItem>
                            </div>
                        </Flex>

                        <Flex gap="gap.medium" className={item.isSelected ? "row row-active fluxo" : "row fluxo"}>
                            {item.fluxoAtendimento?.length > 1 &&
                                <FlexItem>
                                    <div className="chart-container" style={{ width: "95px", height: "60px", position: "relative"}}>
                                        <Chart
                                            title={this.localize("MediaAtendimento")}
                                            type={EChartTypes.LineNoAxes}
                                            data={{
                                                labels: new Array(item.fluxoAtendimento.length),
                                                datasets: [
                                                    {
                                                        data: item.fluxoAtendimento.length ? item.fluxoAtendimento.map((item: any) => item.sum) : [],
                                                    }
                                                ],
                                            }}
                                            theme={this.theme}
                                        />
                                        <div
                                            style={{ position: "absolute", right: "-50px", top: "0", lineHeight: "53px" }}
                                        >
                                            {new Intl.NumberFormat(this.props.i18n.language).format(item.fluxoAtendimentoTotal)}
                                        </div>
                                    </div>
                                </FlexItem>
                            }
                        </Flex>

                        <Flex gap="gap.medium" vAlign="center" className={item.isSelected ? "row row-active" : "row"}>
                            <FlexItem>
                                <Text content={new Intl.NumberFormat(this.props.i18n.language).format(item.fluxoAtendimentoHoje)} />
                            </FlexItem>
                        </Flex>

                        <Flex gap="gap.medium" hAlign="center" vAlign="center" className={item.isSelected ? "favorites row row-active" : "favorites row"}>
                            <FlexItem>
                                <ThumbtackIcon
                                    styles={{ cursor: "pointer" }}
                                    outline={!item.favorite}
                                    onClick={() => this.setFavorite(item, item.ancora, j)}
                                    hidden={item.deleted}
                                />
                            </FlexItem>
                        </Flex>

                    </React.Fragment>);
            }
        }
        else {
            itemsArr.push(
                <Flex hAlign="center" gap="gap.medium" styles={{ marginTop: '60px', gridColumn: 'span 6' }}>
                    <ExclamationTriangleIcon outline />
                    <Text size="small" weight="light" content={this.localize("SemUnidades")} />
                </Flex>
            )
        }

        this.setState({
            loadingRows: false,
            segmentRows: itemsArr
        })
    }

    public render() {
        let pageSize = [10, 25, 50];
        let index = pageSize.indexOf(this.state.pageSize);

        return (
            this.isLoading() ?
                <Loader />
                :
                <div className={this.state.collapsed ? "main-component-serventias" : "main-component-serventias nocollapsed"}>
                    <div className={"form-container"}>
                        <Flex className="charts" gap="gap.large" space="between">
                            <FlexItem size="size.quarter">
                                <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                    {<VisaoGeralAtendimentos
                                        metrics={this.state.atendimentosMetricsFiltered}
                                        filter={this.getAtendimentosFilteredMetrics}
                                        index={this.state.atendimentosIndex}
                                        collapseCharts={this.collapseCharts}
                                        collapsed={this.state.collapsed}
                                    />}
                                </Segment>
                            </FlexItem>

                            <FlexItem size="size.quarter">
                                <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                    {<VisaoGeralUnidades
                                        metrics={this.state.unidadesMetricsFiltered}
                                        filter={this.getUnidadesFilteredMetrics}
                                        index={this.state.unidadesIndex}
                                        collapseCharts={this.collapseCharts}
                                        collapsed={this.state.collapsed}
                                        theme={this.theme}
                                    />}
                                </Segment>
                            </FlexItem>

                            <FlexItem size="size.half">
                                <Segment styles={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                                    {<RelatorioAtendimentos
                                        metrics={this.state.relatorioAtendimentosFilteredMetrics}
                                        filter={this.getRelatorioAtendimentosFilteredMetrics}
                                        index={this.state.relatorioAtendimentosIndex}
                                        collapseCharts={this.collapseCharts}
                                        collapsed={this.state.collapsed}
                                        theme={this.theme}
                                    />}
                                </Segment>
                            </FlexItem>
                        </Flex>

                        <div style={{ boxShadow: "rgba(0 0 0 / 10%) 0px 0.2rem 0.4rem -0.075rem" }}>
                            <ToolbarHome
                                items={this.state.items}
                                isAdmin={this.state.isAdmin}
                                role={this.state.role}
                                setup={this.state.setup}
                                onEditBalcaoVirtual={this.onEditBalcaoVirtual}
                                selectedItem={this.state.selectedItem}
                                searchParam={this.searchParam}
                                agendar={this.agendar}
                                copyEnderecoPublicoToClipboard={this.copyEnderecoPublicoToClipboard}
                                onNewBalcaoVirtual={this.onNewBalcaoVirtual}
                                configAppSettings={this.configAppSettings}
                                reportUrl={this.state.reportUrl}
                                dashboardTask={this.dashboardTask}
                                homeTask={this.homeTask}
                                totalFilterChecked={this.state.totalFilterChecked}
                                clearFilter={this.clearFilter}
                                itemsSecaoFilter={this.state.itemsSecaoFilter}
                                renderFilters={this.renderFilters}
                                index={index}
                                search={this.search}
                                filterView={this.filterView}
                                selectedViewFilterLocale={this.state.selectedViewFilterLocale}
                                totalMetrics={this.state.atendimentosTotalMetrics}
                                collapseCharts={this.collapseCharts}
                                collapsed={this.state.collapsed}
                                theme={this.theme}
                                pinnedAncoras={this.state.pinnedAncoras}
                            />

                            <div className="form-content-container" >
                                <Grid columns="0.8fr 0.1fr 0.5fr 0.3fr 0.2fr">
                                    <Flex gap="gap.small" className="header">
                                        <FlexItem>
                                            <Text content={this.localize("NomeUnidade")} className="margin-style header-nome-serventia" />
                                        </FlexItem>
                                        <FlexItem>
                                            <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={this.localize("InfoUnidade")} />
                                        </FlexItem>
                                        <FlexItem>
                                            <Icon className="margin-style title-sort-icon" iconName={this.state.sortDirection} onClick={() => this.sortDataByColumn("Name", "sortDirection")}>
                                            </Icon>
                                        </FlexItem>
                                    </Flex>

                                    <Flex gap="gap.small">

                                    </Flex>

                                    <Flex gap="gap.small" className="header fluxo">
                                        <FlexItem>
                                            <Text className="margin-style" content={this.localize("FluxoAtendimento")} />
                                        </FlexItem>
                                        <FlexItem>
                                            <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={this.localize("InfoFluxo")} />
                                        </FlexItem>
                                        <FlexItem>
                                            <Icon hidden className="margin-style title-sort-icon" iconName={this.state.sortDirectionFluxo} onClick={() => this.sortDataByColumn("FluxoAtendimentoTotal", "sortDirectionFluxo")}>
                                            </Icon>
                                        </FlexItem>
                                    </Flex>

                                    <Flex gap="gap.small" className="header">
                                        <FlexItem>
                                            <Text className="margin-style" content={this.localize("Hoje")} />
                                        </FlexItem>
                                        <FlexItem>
                                            <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={this.localize("InfoHoje")} />
                                        </FlexItem>
                                        <FlexItem>
                                            <Icon hidden className="margin-style title-sort-icon" iconName={this.state.sortDirectionHoje} onClick={() => this.sortDataByColumn("FluxoAtendimentoHoje", "sortDirectionHoje")}>
                                            </Icon>
                                        </FlexItem>
                                    </Flex>

                                    <Flex gap="gap.small" className="header">
                                        <FlexItem>
                                            <Text className="margin-style" content={this.localize("Favorito")} />
                                        </FlexItem>
                                        <FlexItem>
                                            <Tooltip trigger={<Icon className="margin-style info-icon" iconName="Info" />} content={this.localize("InfoFavorito")} />
                                        </FlexItem>
                                        <FlexItem>
                                            <Icon className="margin-style title-sort-icon" iconName={"Down"} onClick={() => this.sortDataByColumn("Favorite", "Down")}>
                                            </Icon>
                                        </FlexItem>
                                    </Flex>

                                    {this.state.loadingRows &&
                                        <Segment styles={{ gridColumn: 'span 6', background: 'transparent', paddingTop: '0px', boxShadow: 'none' }}>
                                            <LoaderList />
                                        </Segment>
                                    }
                                    {!this.state.loadingRows && this.state.segmentRows}

                                </Grid>
                            </div>
                        </div>
                    </div>

                    <div className="footer-container">
                        <Flex gap="gap.medium" vAlign="center">
                            <FlexItem size="size.half">
                                <Dropdown
                                    inverted
                                    className="unidades-count"
                                    value={this.state.totalItemsCount + ` ${this.localize("UnidadesCadastradas")}`}
                                />
                            </FlexItem>
                            <FlexItem size="size.quarter">
                                <Pagination
                                    callbackFromParent={this.setActivePage}
                                    entitiesLength={this.state.totalItemsCount}
                                    activePage={this.state.activePage}
                                    numberOfContents={this.state.pageSize}
                                />
                            </FlexItem>
                            <FlexItem size="size.half" push>
                                <div className="div-style">
                                    <Dropdown
                                        fluid={true}
                                        items={pageSize}
                                        placeholder={this.localize("ItensPorPagina")}
                                        highlightedIndex={index}
                                        checkable
                                        inverted
                                        getA11ySelectionMessage={{
                                            onAdd: (item: any) => {
                                                this.getMeetingsData();
                                                this.getMeetingsPagedData(0, item, this.state.searchFilter, undefined, undefined, this.state.secaoJudiciariaChecked, this.state.selectedViewFilter)

                                                this.setState({
                                                    activePage: 0,
                                                    pageSize: item,
                                                });

                                                return item.content;
                                            }
                                        }}
                                    />
                                </div>
                            </FlexItem>
                        </Flex>
                    </div>
                </div>
        );
    }
}

const serventiasWithTranslation = withTranslation()(Serventias);
export default serventiasWithTranslation;